'use client';

import { useDraftModeEnvironment } from 'next-sanity/hooks';
import Link from 'next/link';

export function DisableDraftMode() {
    const environment = useDraftModeEnvironment();

    // Only show the disable draft mode button when outside of Presentation Tool
    if (environment !== 'live' && environment !== 'unknown') {
        return null;
    }

    return (
        <Link
            href="/api/draft-mode/disable"
            className="fixed top-6 right-6 z-[9999] flex items-center gap-2 rounded-full border border-black/10 bg-white/80 px-4 py-2 text-xs font-medium text-black shadow-sm backdrop-blur-md transition-all hover:bg-black hover:text-white active:scale-95"
        >
            <div className="h-2 w-2 animate-pulse rounded-full bg-emerald-500" />
            <span>Exit Draft Mode</span>
        </Link>
    );
}
